import { memo } from "react";
import { PlusIcon } from "@/icons";
import styles from "@/interface/RightSheet/Presentations/PresentationsNavigator/PresentationView/PresentationView.module.scss";

export const AddSlideButton = memo(({ onAddFrame }: { onAddFrame: () => void }) => (
    <div className={styles.addButtonWrapper}>
        <button type="button" className={styles.addButton} onClick={onAddFrame}>
            <PlusIcon />
        </button>
    </div>
));
